import React from 'react'
import { GET_IMAGE_COUNTS } from 'operations/Object'
import { Query } from 'react-apollo'
import Card from 'components/Card'
import calculateSize from 'components/CalculateSize'
import Grid from 'components/CSSGrid'

export function Dashboard () {

    return(
        <div>
            <h1>Dashboard</h1>
            <Query query={ GET_IMAGE_COUNTS } pollInterval={5000}>
                {({ loading, error, data }) => {
                    if (loading) return 'Loading...';
                    if (error) return `Error! ${error.message}`;
            
                    return (
                        <Grid>
                            <Card title='Images'>{ data.objectsConnection.aggregate.count }</Card>
                            <Card title='Storage'>{ calculateSize(data.objectsConnection.aggregate.storage) }</Card>
                            <Card title='Bandwidth'>{ calculateSize(data.objectsConnection.aggregate.bandwidth) }</Card>
                        </Grid>
                    );
                }}
            </Query>
        </div>
    )

}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js